import React, { useCallback } from 'react'
import styled, { css } from 'styled-components'
import { observer } from 'mobx-react'
import { useRouter } from 'next/router'
import { useUserStore } from 'store/userStore'

import { tabletSize } from 'theme'
import { hidden } from './mixin'
import { LoginLoader } from 'components/ContentLoaderV2'
import { loginThenReload, logoutThenReload } from 'utils/sdkUtil'
import { useTrackingStore } from 'store/trackingStore'
import { COUPON_SCREEN_NAME, EVENT_ACTION, BUTTON_NAME } from 'tracking'
import loginImage from '/static/images/login.png'
import defaultAvatarImg from '/static/images/default-avatar.png'
import { Button } from '../Skus/SkuCard'

const Login = observer(({ inSideMenu }) => {
  const { userProfile, isLoggedIn, firstLoadingDone } = useUserStore()
  const router = useRouter()
  const { trackEvent } = useTrackingStore()
  const text = isLoggedIn ? '登出' : '登入'
  const avatarImg = isLoggedIn
    ? (userProfile && userProfile.avatar) || defaultAvatarImg
    : loginImage
  const userName = isLoggedIn ? userProfile && userProfile.firstName : '未登入'
  const screenName = router.pathname.substr(1).toUpperCase()

  const trackLogin = useCallback(
    (hasLogin, screenName) =>
      trackEvent(EVENT_ACTION.CLICK, {
        screen: COUPON_SCREEN_NAME[screenName],
        button: hasLogin ? BUTTON_NAME.LOGOUT : BUTTON_NAME.LOGIN,
      }),
    [trackEvent]
  )
  const onLoginOrLogout = useCallback(async () => {
    isLoggedIn ? await logoutThenReload() : await loginThenReload()
    trackLogin(isLoggedIn, screenName)
  }, [isLoggedIn, screenName, trackLogin])

  if (!firstLoadingDone) {
    return (
      <LoginWrapper>
        <LoginLoader />
      </LoginWrapper>
    )
  }

  if (inSideMenu) {
    return (
      <LoginInSideMenuWrapper>
        <UserInfoWrapper>
          <StyledImg
            size={isLoggedIn ? 48 : 32}
            src={avatarImg}
            hasBorderRadius={isLoggedIn}
          />
          {userName}
        </UserInfoWrapper>
        <StyledButton onClick={onLoginOrLogout}>{text}</StyledButton>
      </LoginInSideMenuWrapper>
    )
  }

  return (
    <LoginWrapper>
      <StyledImg src={avatarImg} hasBorderRadius={isLoggedIn} />
      <LoginTextButton onClick={onLoginOrLogout}>{text}</LoginTextButton>
    </LoginWrapper>
  )
})

const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${(p) => p.theme.color.dark200};

  @media ${tabletSize} {
    ${hidden};
  }
`

const LoginTextButton = styled.span`
  cursor: pointer;
`

const UserInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`

const LoginInSideMenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px;
  border-bottom: 1px solid ${(p) => p.theme.color.grey50};
`

const StyledImg = styled.img`
  width: ${(p) => `${p.size || 32}px`};
  height: ${(p) => `${p.size || 32}px`};
  margin-right: 8px;
  ${(p) =>
    p.hasBorderRadius &&
    css`
      border-radius: 50%;
    `}
`

const StyledButton = styled(Button)`
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  font-size: 14px;
  min-width: 60px;
  box-sizing: border-box;
`

export default Login
